import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import Modal from "react-responsive-modal"
import submitData from "helpers/submitData"
import _ from "lodash"
import fieldStatus from "helpers/fieldStatus"
import settings from "settings"
import helpers from "helpers/helpers"
import DateField from "components/DateField"
import { Formik, Field, Form } from "formik"
import { toast } from "react-toastify"
import Dropzone from "react-dropzone"
import * as Yup from "yup"
import { GridContextProvider, GridDropZone, GridItem } from "react-grid-dnd"
import request from "superagent"

class ArcFinalReview extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			data: false,
			files: [],
		}
	}

	componentDidMount() {
		this.build()
	}

	componentDidUpdate(prevProps) {
		//if (!_.isEqual(prevProps, this.props)) { // this was causing socketio events to wipe out state because build() ran.
		if (prevProps.id != this.props.id) {
			this.build()
		}
	}

	validation = () => {
		return Yup.object().shape({
			schedule_date: Yup.number().required("Required"),
		})
	}

	build = () => {
		let lot = _.find(this.props.payload.exec.lots, { id: this.props.id })
		if (lot) {
			this.setState({
				data: lot,
				approvalComments: _.get(lot, `arc_data.fr_approval_comments`) || "",
				rejectionReason: _.get(lot, `arc_data.fr_rejection_reason`) || "",
				schedule_date: _.get(lot, `arc_data.fr_schedule_date`) || "",
				files: _.get(lot, `arc_data.fr_files`) || [],
			})
		} else {
			this.setState({ data: false })
		}
	}

	notify = () => {
		this.setState({ buyerData: [], buyerModal: false })
		toast.success("Updated Profile")
	}

	saveComments = () => {
		let f = {
			lot_id: this.state.data.id,
			fr_approval_comments: this.state.approvalComments,
			fr_rejection_reason: this.state.rejectionReason,
			action: "arcFinalReviewUpdateNotes",
		}
		submitData("mainIngest", f)
			.then((data) => {
				toast.success(data.message)
				this.props.getPayload()
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	answerLotReview = (status) => {
		let data = {
			id: this.state.data.id,
			status,
		}
		if (status) {
			data.approval_comments = this.state.approvalComments
		} else if (!status) {
			data.reason = this.state.rejectionReason
		}
		data.action = "arcFinalReviewAnswer"

		submitData("mainIngest", data)
			.then((data) => {
				this.props.notify(data, "finalModal")
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	onDrop = (files) => {
		this.props.loadingStatus(true)
		const req = request.post(`${settings.ep}/addFinalReviewFile`)
		for (let file of files) {
			req.attach(file.name, file)
		}
		req.field("id", this.state.data.id)
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.end((err, response) => {
			//return
			let resp = response.body

			if (err) {
				console.log(err)
				toast.error(resp.message)
			}
			if (resp.status == 200) {
				toast.success(resp.message)
				this.setState({ files: resp.arr })
			}
			this.props.loadingStatus(false)
		})
	}

	removeImage = (k, f) => {
		let files = _.clone(this.state.files)
		files.splice(k, 1)
		this.setState({ files })
		let values = {
			id: this.state.data.id,
			files,
			action: "arcFinalReviewRemoveFile",
		}
		submitData("mainIngest", values).then((data) => {
			toast.success(data.message)
		})
	}

	compileThumbs = () => {
		if (!this.state.files) return ""
		const arrayMove = require("array-move")
		const onChange = async (sourceId, sourceIndex, targetIndex) => {
			let files = _.clone(this.state.files)
			files = arrayMove(files, sourceIndex, targetIndex)
			files = _.compact(files)
			this.setState({ files })
			let resp = await submitData("mainIngest", {
				action: "arcFinalReviewReorderFiles",
				id: this.state.data.id,
				files,
			})
			if (resp.status == 200) {
				toast.success(resp.message, { autoClose: 2000 })
			}
		}
		let rows = Math.ceil(this.state.files.length / 4)
		let height = rows * 220
		return (
			<GridContextProvider onChange={onChange}>
				<GridDropZone
					id="items"
					boxesPerRow={4}
					rowHeight={200}
					style={{ height: `${height}px`, width: "100%" }}>
					{this.state.files.map((item, k) => {
						let url = `${settings.s3}/${item}`
						// Parantheses in filename break image thumbnail
						url = decodeURI(url) // decding first because some url's are encoded already....% then gets to %25.
						url = encodeURI(url)
						url = url.replace(/\(/g, "%28").replace(/\)/g, "%29")
						let isFile = !/\.(jpg|jpeg|png)$/.test(item)
						let fileName
						if (isFile) {
							fileName = item.split("/").pop()
							fileName = fileName.split("-").slice(2).join("-")
						}
						let icon = (
							<div
								className="imageZone__thumb bg-gray-300 flex justify-center items-center"
								key={`thumb` + item}
								style={{
									backgroundImage: `url(${url})`,
								}}>
								<i
									className="fas fa-times-circle formFiles__removeIcon"
									onClick={() => this.removeImage(k)}></i>
								{isFile ? (
									<a href={url} target="_blank" className="flex items-center">
										<div className="border border-dashed border-gray-500 p-3 flex justify-center flex-col items-center">
											<i className="fas fa-arrow-down"></i>
											<span className="block text-xs">{fileName}</span>
										</div>
									</a>
								) : null}
							</div>
						)
						return (
							<GridItem key={item} className="imageZone__block">
								<div
									className="imageGridItem"
									style={{
										width: "100%",
										height: "100%",
										paddingBottom: "20px",
										paddingRight: "20px",
									}}>
									{icon}
								</div>
							</GridItem>
						)
					})}
				</GridDropZone>
			</GridContextProvider>
		)
	}

	render() {
		if (!this.state.data) {
			return ""
		}
		const { open } = this.props
		let arcData = this.state.data.arc_data
		if (!arcData) return ""
		let section = ""
		let secLook = _.find(this.props.payload.public.sections, { id: this.state.data.section_id })
		if (secLook) {
			section = secLook.name
		}
		let builder = _.find(this.props.payload.public.builders, { id: this.state.data.builder })
		let builderName = builder ? ` | ${builder.name}` : ""
		let sp = _.find(this.props.payload.public.salespeople, { id: arcData.user })
		let salesperson = sp ? ` | ${sp.first} ${sp.last}` : ""
		return (
			<div>
				<Modal open={open} onClose={this.props.onClose} center classNames={{ modal: "arcModal" }}>
					<div className="flex">
						<h3 className="mr-10">
							Final Review Submission: {this.state.data.address}
							{builderName}
							{salesperson} | {this.state.data.lot}/{this.state.data.block}/{section}
						</h3>
						{this.state?.data?.arc_data?.fr_plan_file ? (
							<p>
								<a
									className="btn"
									href={`${settings.s3}${this.state.data.arc_data.fr_plan_file}`}
									target="_blank">
									View File
								</a>
							</p>
						) : null}
					</div>
					<h2>
						Approval{" "}
						<span
							onClick={() => this.saveComments()}
							style={{ marginLeft: 10, fontSize: 12, cursor: "pointer" }}>
							<i className="fas fa-cloud-download" style={{ marginRight: 4 }} />
							Save Comments
						</span>
					</h2>
					<div className="arcModal__approvalBox">
						<div style={{ marginRight: 25 }}>
							<p>Approval Comments</p>
							<textarea
								onChange={(v) => this.setState({ approvalComments: v.target.value })}
								value={this.state.approvalComments}></textarea>
							<div className="arcModal__approve" onClick={() => this.answerLotReview(true)}>
								Approve
							</div>
						</div>
						<div className="arcModal__rejectionBox">
							<p>Rejection Reason:</p>
							<textarea
								onChange={(v) => this.setState({ rejectionReason: v.target.value })}
								value={this.state.rejectionReason}></textarea>
							<div className="arcModal__rejection" onClick={() => this.answerLotReview(false)}>
								Reject
							</div>
						</div>
					</div>
					<div className="my-10 flex">
						<div className="flex-1">
							<h2>Schedule Final Review</h2>
							<Formik
								initialValues={{
									schedule_date: this.state.schedule_date,
								}}
								validationSchema={this.validation}
								isInitialValid={true}
								validateOnMount={true}
								onSubmit={(values) => {
									this.props.loadingStatus(true)
									values.action = "arcFinalReviewSchedule"
									values.id = this.state.data.id
									submitData("mainIngest", values).then((data) => {
										this.props.loadingStatus(false)
										toast.success(data.message)
										this.props.getPayload()
									})
								}}>
								{(f) => (
									<Form>
										<ul className="form__list">
											<li className={fieldStatus("schedule_date", f, false, false, true)}>
												<label htmlFor="schedule_date">Review Date</label>
												<DateField
													name="schedule_date"
													className="form__textarea"
													value={f.values.schedule_date}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.schedule_date}
													error={f.errors.schedule_date}
												/>
											</li>
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								)}
							</Formik>
						</div>
						<div className="flex-2 pl-8">
							<h2>Files</h2>
							<div className="flex">
								<div>
									<Dropzone
										multiple={true}
										onDrop={(files) => {
											this.onDrop(files)
										}}>
										{({ getRootProps, getInputProps }) => (
											<section className="dropzone">
												<div {...getRootProps()} className="dropbox__cont">
													<input {...getInputProps()} />
													<p className="dropzone__action">
														Drag 'n' drop file here, or click to select files
													</p>
												</div>
											</section>
										)}
									</Dropzone>
								</div>
								<div className="w-full pl-4">{this.compileThumbs()}</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ArcFinalReview)
